import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './contexts/userContext'; // Ensure this path is correct
import { CartProvider } from './contexts/cartContext';
import { UserExchangeProvider } from './contexts/userExchangeProgramContext';
import { RefreshProvider } from './contexts/refreshLogin';
import { RefreshPriceProvider } from './contexts/refreshPrice';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import 'owl.carousel/dist/assets/owl.carousel.min.css';
// import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import $ from 'jquery';  // This will ensure jQuery is available globally
  // Make sure it's available globally for other scripts, like Owl Carousel


const rootElement = document.getElementById('root');
const gtmId = process.env.REACT_APP_GTM_ID;
const clarityId = process.env.REACT_APP_CLARITY_ID;
const showgtm = process.env.REACT_APP_SHOW_GTM
const facebookPixelId = process.env.REACT_APP_FACEBOOK_PIXEL_ID;
const fbShow = process.env.REACT_APP_SHOW_FACEBOOK

// global.d.ts
interface window {
  fbq: any;  // Declare 'fbq' property on window as any type
}

// console.log("index---GTM ID: ", gtmId,showgtm,clarityId);

// Inject Google Tag Manager (GTM) script
if(showgtm === 'yes'){

  if(fbShow === 'yes'){
    if (facebookPixelId) {
      // console.log("Injecting Facebook Pixel Script");
    
      // Inject the Facebook Pixel base code
      (function (f: any, b: Document, p: string, i: string) {
        f.fbq = f.fbq || function () {
          (f.fbq.q = f.fbq.q || []).push(arguments);
        };
        f.fbq('init', i); // Replace `i` with your Pixel ID
        f.fbq('track', 'PageView');
    
        const t = b.createElement(p) as HTMLScriptElement;
        const s = b.getElementsByTagName(p)[0];
        t.async = true;
        t.src = `https://connect.facebook.net/en_US/fbevents.js`;
    
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      })(window, document, 'script', facebookPixelId);
    
      // For tracking events such as a "Purchase"
      
    }
  }
  
  
  
  
}else {
  // console.log('No gtm available')
}




if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  // console.log("index--------",gtmId)
  root.render(
    <React.StrictMode>
      <RefreshPriceProvider>
      <RefreshProvider>
      
      <UserExchangeProvider>
      <UserProvider>
        <CartProvider>
        <App />
        </CartProvider>
      </UserProvider>
    
      </UserExchangeProvider>
      </RefreshProvider>
      </RefreshPriceProvider>
      
     </React.StrictMode>
  );
} else {
  //console.error('Root element not found');
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
